import {
  apiRequest,
  P3KuploadSKP3K,
  P3KdetailCP3K,
  employeeP3kDownloadSPMT,
  p3kDownloadContract,
} from "../../../../../services/adapters/kepegawaian/dokumenP3KService";

class UploadSKRepository {
  fetchUploadSk = async (query) => {
    return await apiRequest(
      "post",
      P3KuploadSKP3K,
      {
        body: query,
      },
      true
    );
  };

  fetchDetail = async (query) => {
    return await apiRequest(
      "get",
      P3KdetailCP3K,
      {
        params: query,
      },
      true
    );
  };

  fetchDownloadSPMT = async (query) => {
    return await apiRequest(
      "get",
      employeeP3kDownloadSPMT,
      {
        params: query,
      },
      true
    );
  };

  fetchDownloadContract = async (query) => {
    return await apiRequest(
      "get",
      p3kDownloadContract,
      {
        params: query,
      },
      true
    );
  };
}

export default UploadSKRepository;
